export function isLocal() {
  const url = new URL(window.location.href).origin
  return url.includes('localhost') || url.includes('127.0.0.1')
}
